"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddInvitationControl = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = require("../../Button");
var AddInvitationControl = function (props) {
    return (react_1.default.createElement("div", { className: "c-dropdown__footer" },
        react_1.default.createElement(Button_1.Button, { className: "c-button +small", onClick: props.onStartAdding }, props.children)));
};
exports.AddInvitationControl = AddInvitationControl;
//# sourceMappingURL=AddInvitationControl.js.map